export default __webpack_public_path__ + "static/media/iplogo-bg.eb11063e.PNG";